(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('rcopia-apis', {
                parent: 'entity',
                url: '/rcopia-apis',
                data: {
                    authorities: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM],
                    pageTitle: 'Rcopia APIs'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/rcopia-ap-i/list/rcopia-ap-i.html',
                        controller: 'RcopiaApiController',
                        controllerAs: 'vm'
                    }
                }
            });
    }
})();
